import { Plus, Users } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

interface QuickActionsProps {
  onCreateLeague?: () => void
  onJoinLeague?: () => void
}

export function QuickActions({ onCreateLeague, onJoinLeague }: QuickActionsProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Quick Actions</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <Button 
          onClick={onCreateLeague}
          className="w-full bg-primary hover:bg-primary/90 h-12"
        >
          <Plus className="h-5 w-5 mr-2" />
          Create League
        </Button>
        
        <Button 
          variant="outline"
          onClick={onJoinLeague}
          className="w-full h-12"
        >
          <Users className="h-5 w-5 mr-2" />
          Join League
        </Button>
      </CardContent>
    </Card>
  )
}